import React from 'react';

const CatIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='m15.93 11.5-1.33.09C13.74 10.57 11.33 8 8.93 8c0 0-1.97 2.96-.04 6.91-.55.83-.89 1.26-.96 2.25L6 17.45l.21.98 1.76-.26.14.71-1.57.94.47.89 1.45-.89c1.15 2.44 4.06 3.68 7.47 3.68s6.32-1.24 7.47-3.68l1.45.89.47-.89-1.57-.94.14-.71 1.76.26.21-.98-1.93-.29c-.07-.99-.41-1.42-.96-2.25C24.9 10.96 22.93 8 22.93 8c-2.4 0-4.81 2.57-5.67 3.59l-1.33-.09m-3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m6 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-4 3h2l-.7 1.39c.2.64.76 1.11 1.45 1.11a1.5 1.5 0 0 0 1.5-1.5h.5a2 2 0 0 1-2 2c-.75 0-1.4-.41-1.75-1-.35.59-1 1-1.75 1a2 2 0 0 1-2-2h.5a1.5 1.5 0 0 0 1.5 1.5c.69 0 1.25-.47 1.45-1.11l-.7-1.39z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </svg>
);

export default CatIcon;
